<template>
    <div>
        <!--      <div class="page-title">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h3>{{$t('project.title')}}</h3>
                </div>
            </div>
        </div>
    </div>
 -->
        <div class="main-nav">
            <b-navbar toggleable="lg" type="dark" variant="blue">
                <div class="container nav-container">
                    <div class="row">
                        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
                        <b-collapse is-nav id="nav_collapse">
                            <b-navbar-nav class="main-nav">
                                <b-nav-item href="#" class="active"> 
                                  <i class="fa fa-home"></i>
                                    <div class="nav-text">
                                        <span>Home</span>
                                    </div>
                                </b-nav-item>
                                <b-nav-item href="#">
                                    <i class="fa fa-user"></i>
                                    <div class="nav-text">
                                        <span>Aaple Labharthi</span>
                                    </div>
                                </b-nav-item>
                                <b-nav-item href="#">
                                    <i class="fa fa-graduation-cap"></i>
                                    <div class="nav-text">
                                        <span>Aaple Labharthi</span>
                                    </div>
                                </b-nav-item>
                                <b-nav-item href="#">
                                    <i class="fa fa-user-secret"></i>
                                    <div class="nav-text">
                                        <span>Aaple Labharthi</span>
                                    </div>
                                </b-nav-item>
                                <b-nav-item href="#">
                                    <i class="fa fa-briefcase"></i>
                                    <div class="nav-text">
                                        <span>Aaple Labharthi</span>
                                    </div>
                                </b-nav-item>
                                <b-nav-item href="#">
                                    <i class="fa fa-address-card"></i>
                                    <div class="nav-text">
                                        <span>Aaple Labharthi</span>
                                    </div>
                                </b-nav-item>
                                <b-nav-item href="#">
                               
                                    <div class="nav-text">
                                        <span>Aaple Labhardsfthi</span>
                                    </div>
                                </b-nav-item>
                                  <b-nav-item-dropdown right>
        <!-- Using button-content slot -->
        <template slot="button-content">
                <i class="fa fa-address-card"></i>
           <div class="nav-text">
                                        <span>Aaple Labhardsfthi</span>
                                    </div>
        </template>
        <b-dropdown-item href="#">Profile</b-dropdown-item>
        <b-dropdown-item href="#">Signout</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
                            <!-- </b-navbar-nav> -->
                            <!-- Right aligned nav items -->
                        </b-collapse>
                    </div>
                </div>
            </b-navbar>
          
        </div>
    </div>
</template>
<script>
// import axios from 'axios'
// import lodashOrderBy from 'lodash/orderBy'
export default {
  name: 'pageheader',
  data() {
    return {
      isActive: false,
      isOpen: false,
      isOpen2: false
    }
  },
  methods: {
    logout() {
      let vm = this
      window.MKCLAPI.logout()
        .then(() => {
          vm.$store.dispatch('clearStore')
          vm.$router.push('/')
        })
        .catch(e => {
          vm.$toasted.error(vm.$t('logOut.failToLogout'))
        })
    },
    greet: function() {
      // `this` inside methods points to the Vue instance
      var element = document.getElementById('nav1')
      var element2 = document.getElementById('toggle-btn')
      element.classList.toggle('shrinked')
      // `event` is the native DOM event
    },
    toggle: function() {
      this.isOpen = !this.isOpen
      var element3 = document.getElementById('dropdown-top2')
      // element3.classList.remove("show")
    },
    toggle2: function() {
      this.isOpen2 = !this.isOpen2
    },
    search: function() {
      this.isActive = true
    },
    searchclose: function() {
      this.isActive = false
    }
  }
}
</script>

<style scoped>

</style>
